import React from 'react';
import { Modal, Button } from 'antd';

export default function UserDeleteModal({ open, onCancel, onConfirm, user, loading }) {
  return (
    <Modal
      title="Delete user"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="delete"
          danger
          onClick={onConfirm}
          loading={loading}
          className="app-btn-delete"
        >
          Delete
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
    >
      {user && (
        <>
          Are you sure you want to delete <strong>{user.name || user.email}</strong>? This action
          cannot be undone.
        </>
      )}
    </Modal>
  );
}
